var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-navigation-drawer',{attrs:{"app":"","clipped":"","right":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('navigation-drawer-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }